import { connect } from 'react-redux';
import { FC, ReactNode } from 'react';
import { OmitStrict } from '@tink/core/src/types';
import { AppState, ConnectedPropsWithoutDispatch } from '../../../../../stores/redux-store';
import { ProviderInputs, ProviderInputsProps } from './ProviderInputs';
import { ProviderInputsGermany } from './ProviderInputsGermany';

export type ProviderInputsWrapperProps = OmitStrict<ProviderInputsProps, 'intl'> &
  PropsFromRedux & {
    children?: ReactNode;
    isSplitFields: boolean;
  };

export const ProviderInputsWrapperPresenter: FC<ProviderInputsWrapperProps> = ({
  providerFields,
  onSubmit,
  children,
  fixedValue,
  renderProviderFields = true,
  setButtonDisabled,
  isSplitFields = false,
}) => {
  if (isSplitFields) {
    return (
      <ProviderInputsGermany
        setButtonDisabled={setButtonDisabled}
        providerFields={providerFields}
        fixedValue={fixedValue}
        onSubmit={onSubmit}
        renderProviderFields={renderProviderFields}
      >
        {children}
      </ProviderInputsGermany>
    );
  }

  return (
    <ProviderInputs
      setButtonDisabled={setButtonDisabled}
      providerFields={providerFields}
      fixedValue={fixedValue}
      onSubmit={onSubmit}
      renderProviderFields={renderProviderFields}
      shouldPersistFormState
      shouldTrimInputValues
    >
      {children}
    </ProviderInputs>
  );
};

const mapStateToProps = (state: AppState) => ({
  userId: state.user.user?.id || '',
});

const connector = connect(mapStateToProps);

type PropsFromRedux = ConnectedPropsWithoutDispatch<typeof connector>;

export const ProviderInputsWrapper = connector(ProviderInputsWrapperPresenter);
